import { Button, ButtonProps } from "@mui/material";
import { LinkProps } from "react-router-dom";
import UnstyledLink from "./UnstyledLink";

type LinkButtonProps = Pick<LinkProps, "to" | "state"> & ButtonProps;

export default function LinkButton({ to, state, ...buttonProps }: LinkButtonProps) {
  return (
    <UnstyledLink to={to} state={state}>
      <Button {...buttonProps} />
    </UnstyledLink>
  );
}
